import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router does not reset the scroll position when the URL changes, so a
// new page renders at whatever offset the previous one was left at. That is why
// /panel appeared scrolled down after logging in: the login page is min-vh-100
// (scrollable on a phone) and the iOS keyboard scrolls it while the password is
// typed, then navigate("/panel") inherits that offset.
//
// Mounted outside the Suspense boundary in App.js so this runs as soon as the
// URL changes, without waiting for the target route's lazy chunk to resolve.
//
// Keyed on pathname only — query-string changes (filters, pagination) should
// not yank the user back to the top.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
